import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import type { AuthState, AuthResponse } from './types';

export const ACCESS_TOKEN_KEY = 'accessToken';
export const AZURE_ACCESS_TOKEN_KEY = 'azureAccessToken';
const accessToken = localStorage.getItem(ACCESS_TOKEN_KEY);
const azureAccessToken = localStorage.getItem(AZURE_ACCESS_TOKEN_KEY);

const initialState: AuthState = {
  user: null,
  accessToken,
  isAuthenticated: !!accessToken,
  isLoading: false,
  error: null,
  azureAccessToken
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthResponse: (state, action: PayloadAction<AuthResponse>) => {
      const response = action.payload;

      state.user = {
        id: String(response.userId),
        email: response.userEmail,
        name: response.userName,
        role: 'user',
        provider: state.user?.provider || 'azure',
        azureAccessToken: state.azureAccessToken || undefined
      };

      state.accessToken = response.token;
      state.isAuthenticated = true;
      state.error = null;

      localStorage.setItem(ACCESS_TOKEN_KEY, response.token);
    },
    setAzureAccessToken: (state, action: PayloadAction<string | null>) => {
      state.azureAccessToken = action.payload;
      if (state.user) {
        state.user.azureAccessToken = action.payload || undefined;
      }
      if (action.payload) {
        localStorage.setItem(AZURE_ACCESS_TOKEN_KEY, action.payload);
      } else {
        localStorage.removeItem(AZURE_ACCESS_TOKEN_KEY);
      }
    },
    logout: (state) => {
      state.user = null;
      state.accessToken = null;
      state.azureAccessToken = null;
      state.isAuthenticated = false;
      state.isLoading = false;
      state.error = null;
      localStorage.removeItem(ACCESS_TOKEN_KEY);
      localStorage.removeItem(AZURE_ACCESS_TOKEN_KEY);
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    clearError: (state) => {
      state.error = null;
    }
  }
});

export const { setAuthResponse, setAzureAccessToken, logout, setLoading, setError, clearError } = authSlice.actions;
